import { FirestoreDataConverter } from '@angular/fire/firestore';
import { ShipmentParcelContent } from './shipment-parcel-content.model';
import { ObjectHelper } from "../helpers/object.helper";

export class ShipmentParcel {
  id: string; // Id parcel id
  shipmentKey: string; // Key of the shipment
  index: number; // sort index
  content: ShipmentParcelContent[]; // Content of the parcel
  weight: number; // Weight of the parcel in kg
  length: number; // Length of the parcel in cm
  height: number; // Height of the parcel in cm
  width: number; // Width of the parcel in cm
  isPallet: boolean; // The parcel is a pallet
  trackingId: string; // Tracking id of the parcel

  constructor(parcel?: Partial<ShipmentParcel>) {
    this.id = parcel?.id ?? ''
    this.shipmentKey = parcel?.shipmentKey ?? ''
    this.index = parcel?.index ?? 0;
    this.content = (parcel?.content ?? []).map(content => new ShipmentParcelContent(content))
    this.weight = parcel?.weight ?? 0;
    this.length = parcel?.length ?? 0;
    this.height = parcel?.height ?? 0;
    this.width = parcel?.width ?? 0;
    this.isPallet = parcel?.isPallet ?? false;
    this.trackingId = parcel?.trackingId ?? '';
  }

  /**
   * Converter used to convert a parcel from firebase
   */
  static converter: FirestoreDataConverter<ShipmentParcel> = {
    toFirestore: (parcel: ShipmentParcel) => ({
      id: parcel.id,
      shipmentKey: parcel.shipmentKey,
      index: parcel.index,
      content: ObjectHelper.anonymize(parcel.content),
      weight: parcel.weight,
      length: parcel.length,
      height: parcel.height,
      width: parcel.width,
      isPallet: parcel.isPallet,
      trackingId: parcel.trackingId,
    }),
    fromFirestore: (snapshot, options) =>
      new ShipmentParcel({ ...snapshot.data(options), id: snapshot.id })
  };
}
